import { Controller } from "@hotwired/stimulus"

// Submits a filter form shortly after typing stops, so an admin list narrows as you type.
// Dropdowns apply straight away.
//
// Put this on the form and point the form at a turbo frame wrapping the results: only the
// frame is replaced, so the text field keeps focus and the caret stays where it was. Without
// a frame this would reload the whole page and the admin would lose the field mid-word.
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  disconnect() {
    clearTimeout(this.timer)
  }

  // Typing — wait for a pause so each keystroke isn't a request.
  search() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  submit() {
    clearTimeout(this.timer)
    this.element.requestSubmit()
  }
}
